/**
 * Блокировка/разблокировка скролла
 */

class LockScroll {
    constructor() {
        this.scroll = 0;
    }

    lock() {
        /**
         * Так как страница перепрыгивает вверх,
         * когда срабатывает overflow:hidden,
         * принудительно сколлим её до
         * запомненного состояния
         */
        this.scroll = window.scrollY;

        document.querySelector('body').classList.add('_noscroll');
        window.scroll(0, this.scroll);
    }

    unlock() {
        document.querySelector('body').classList.remove('_noscroll');
        window.scroll(0, this.scroll);
    }
}

App.lockScroll = new LockScroll();



// WEBPACK FOOTER //
// ./_src/js/LockScroll.js